// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileMoreModal_modal__BK5R2 {
  padding: 0;
  align-items: flex-start;
  background: none;
  z-index: 3;
}
.MobileMoreModal_modal__BK5R2 .modal__inner {
  max-width: none;
  border-radius: 0;
  height: calc(100% - 66px);
  overflow: auto;
  margin: 0;
}

.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_MobileMoreModalContent__4Cv8e {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.MobileMoreModal_MobileMoreModal__xVFtD .modal__body {
  padding: 24px;
  height: 100%;
}
.MobileMoreModal_MobileMoreModal__xVFtD .support {
  display: flex;
  justify-content: center;
}
.MobileMoreModal_MobileMoreModal__xVFtD .footer {
  margin: auto 0 0;
  display: flex;
  justify-content: center;
  max-width: none;
}
.MobileMoreModal_MobileMoreModal__xVFtD .footer .footer__wp {
  padding: 0;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 340px;
}
.MobileMoreModal_MobileMoreModal__xVFtD .footer .footer__wp p {
  font-size: 12px;
  line-height: 14px;
}
@media (min-width: 640px) {
  .MobileMoreModal_MobileMoreModal__xVFtD .footer .footer__wp {
    max-width: none;
  }
  .MobileMoreModal_MobileMoreModal__xVFtD .footer .footer__wp p {
    font-size: 18px;
    line-height: 20px;
  }
}
.MobileMoreModal_MobileMoreModal__xVFtD .footer .footer__logoWrap {
  display: none;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR h2 {
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
}
@media (min-width: 640px) {
  .MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR h2 {
    font-size: 22px;
    line-height: 28px;
  }
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__BZ7jT {
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  box-shadow: 0 5px 9px 0 rgba(0, 0, 0, 0.0509803922);
  border-radius: 12px;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__icon__gNlOV {
  width: 36px;
  height: 36px;
  background: #FAFAFA;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__icon--yellow__Lv32A {
  background: #FED45A;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__icon--yellow__Lv32A svg {
  fill: white;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__icon__gNlOV.MobileMoreModal_lang-icon__hdqcZ img {
  width: 24px;
  height: 24px;
  border-radius: 12px;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__icon__gNlOV.MobileMoreModal_exit-icon__bv3H6 {
  transform: rotate(180deg);
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__content__060hS {
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 48px);
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__content__txt__7lyTA {
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_content-container__2nBWR .MobileMoreModal_content-list__RIm7b .MobileMoreModal_item__content__desc__2SGz6 {
  font-size: 12px;
  line-height: 13px;
  color: #7A808B;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_quantity-indicator__EwcHf {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 11px;
  line-height: 11px;
  background: #FF3C3C;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 2px solid #FAFAFA;
  color: #FAFAFA;
  display: flex;
  align-items: center;
  justify-content: center;
}
.MobileMoreModal_MobileMoreModal__xVFtD .MobileMoreModal_quantity-indicator__EwcHf.MobileMoreModal_quantity-indicator__bigger__wOcxp {
  width: 26px;
  height: 26px;
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/MobileMoreModal/MobileMoreModal.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;AACF;AAGM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;AADR;;AAQE;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AALN;AASI;EACE,aAAA;EACA,YAAA;AAPN;AAUI;EACE,aAAA;EACA,uBAAA;AARN;AAWI;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AATN;AAWM;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AATR;AAWQ;EACE,eAAA;EACA,iBAAA;AATV;AAYQ;EAbF;IAcI,eAAA;EATR;EAWQ;IACE,eAAA;IACA,iBAAA;EATV;AACF;AAaM;EACE,aAAA;AAXR;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAdJ;AAgBI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAdN;AAgBM;EALF;IAMI,eAAA;IACA,iBAAA;EAbN;AACF;AAgBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAdN;AAgBM;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mDAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAdR;AAgBQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdV;AAgBU;EACE,mBAAA;AAdZ;AAgBY;EACE,WAAA;AAdd;AAmBY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAjBd;AAqBU;EACE,yBAAA;AAnBZ;AAuBQ;EACE,aAAA;EACA,sBAAA;EACA,4BAAA;AArBV;AAuBU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AArBZ;AAwBU;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAtBZ;AA6BE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3BJ;AA6BI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA3BN","sourcesContent":[".modal {\n  padding: 0;\n  align-items: flex-start;\n  background: none;\n  z-index: 3;\n\n  :global {\n    .modal {\n      &__inner {\n        max-width: none;\n        border-radius: 0;\n        height: calc(100% - 66px);\n        overflow: auto;\n        margin: 0;\n      }\n    }\n  }\n}\n\n.MobileMoreModal {\n  .MobileMoreModalContent {\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n    }\n\n  :global {\n    .modal__body {\n      padding: 24px;\n      height: 100%;\n    }\n\n    .support {\n      display: flex;\n      justify-content: center;\n    }\n\n    .footer {\n      margin: auto 0 0;\n      display: flex;\n      justify-content: center;\n      max-width: none;\n\n      .footer__wp {\n        padding: 0;\n        margin-top: 24px;\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        max-width: 340px;\n\n        p {\n          font-size: 12px;\n          line-height: 14px;\n        }\n\n        @media (min-width: 640px) {\n          max-width: none;\n\n          p {\n            font-size: 18px;\n            line-height: 20px;\n          }\n        }\n      }\n\n      .footer__logoWrap {\n        display: none;\n      }\n    }\n  }\n\n  .content-container {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 24px;\n\n    h2 {\n      font-size: 16px;\n      line-height: 18px;\n      font-weight: 600;\n\n      @media(min-width: 640px) {\n        font-size: 22px;\n        line-height: 28px;\n      }\n    }\n\n    .content-list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      .item {\n        padding: 12px 16px;\n        display: flex;\n        gap: 12px;\n        box-shadow: 0 5px 9px 0 #0000000D;\n        border-radius: 12px;\n        align-items: center;\n        cursor: pointer;\n        position: relative;\n\n        &__icon {\n          width: 36px;\n          height: 36px;\n          background: #FAFAFA;\n          border-radius: 30px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &--yellow {\n            background: #FED45A;\n\n            svg {\n              fill: white;\n            }\n          }\n\n          &.lang-icon {\n            img {\n              width: 24px;\n              height: 24px;\n              border-radius: 12px;\n            }\n          }\n\n          &.exit-icon {\n            transform: rotate(180deg);\n          }\n        }\n\n        &__content {\n          display: flex;\n          flex-direction: column;\n          max-width: calc(100% - 48px);\n\n          &__txt {\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 18px;\n          }\n\n          &__desc {\n            font-size: 12px;\n            line-height: 13px;\n            color: #7A808B;\n          }\n        }\n      }\n    }\n  }\n\n  .quantity-indicator {\n    position: absolute;\n    top: -5px;\n    right: -5px;\n    font-size: 11px;\n    line-height: 11px;\n    background: #FF3C3C;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    border: 2px solid #FAFAFA;\n    color: #FAFAFA;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &.quantity-indicator__bigger {\n      width: 26px;\n      height: 26px;\n      font-size: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `MobileMoreModal_modal__BK5R2`,
	"MobileMoreModal": `MobileMoreModal_MobileMoreModal__xVFtD`,
	"MobileMoreModalContent": `MobileMoreModal_MobileMoreModalContent__4Cv8e`,
	"content-container": `MobileMoreModal_content-container__2nBWR`,
	"content-list": `MobileMoreModal_content-list__RIm7b`,
	"item": `MobileMoreModal_item__BZ7jT`,
	"item__icon": `MobileMoreModal_item__icon__gNlOV`,
	"item__icon--yellow": `MobileMoreModal_item__icon--yellow__Lv32A`,
	"lang-icon": `MobileMoreModal_lang-icon__hdqcZ`,
	"exit-icon": `MobileMoreModal_exit-icon__bv3H6`,
	"item__content": `MobileMoreModal_item__content__060hS`,
	"item__content__txt": `MobileMoreModal_item__content__txt__7lyTA`,
	"item__content__desc": `MobileMoreModal_item__content__desc__2SGz6`,
	"quantity-indicator": `MobileMoreModal_quantity-indicator__EwcHf`,
	"quantity-indicator__bigger": `MobileMoreModal_quantity-indicator__bigger__wOcxp`
};
export default ___CSS_LOADER_EXPORT___;
